export const translations = {
  en: {
    market: {"noOptions":"No matching options","filtersSort":"Filter & sort","showResults":"Show results","loadMore":"Load more vehicles","removeFilter":"Remove filter","loadError":"Unable to load vehicles. Please try again.","retry":"Try again"},
    nav: {
      listNow: "List Now",
      home: "Home",
      openMenu: "Open menu",
      closeMenu: "Close menu",
      menu: "Menu",
      navigation: "Main navigation",
      language: "Language",
      appearance: "Appearance",
      light: "Light",
      dark: "Dark",
      buy: "Browse vehicles",
      sell: "Sell",
      dealers: "Dealers",
      about: "About",
      listCar: "List Now",
      listVehicle: "List Now",
      listVehicleShort: "List Now",
      logIn: "Log In",
      myAccount: "My Account",
      myDashboard: "My Dashboard",
    },
    common: {
      loading: "Loading…",
      testingEnvironment: "TESTING — sample data",
    },
    notFound: {
      code: "404",
      title: "Page not found",
      body: "The page you're looking for doesn't exist or has been moved.",
      cta: "Back to Home",
    },
    logout: {
      signingOut: "Signing out…",
    },
    errors: {
      boundaryTitle: "Something went wrong",
      boundaryBody: "An unexpected error occurred. Please try refreshing the page.",
      refresh: "Refresh Page",
    },
    carva: {
      categories: {
        cars: "Cars",
        motorcycles: "Motorcycles",
        classics: "Classic Cars",
      },
      home: {
        listHint: "Create an ad for your vehicle",
        badge: "Kuwait's Premium Vehicle Marketplace",
        heroTitle1: "Buy & Sell Any",
        heroTitle2: "Vehicle in Kuwait",
        heroSubtitle:
          "Find your next vehicle. Connect directly with sellers.",
        browsePrefix: "Browse",
        browseArrow: "→",
        searchPlaceholder: "Make, model, or keyword",
        searchButton: "Search",
        featuredPinnedTitle: "Featured — pinned picks",
        latestTitle: "Latest listings",
        footerGuides: "Guides",
        footerHelp: "Help",
        footerDealers: "Featured dealers",
        browseByMake: "Browse by Make",
        browseByMakeSub: "Find your favorite brand",
        featuredLine: "Featured",
        seeAll: "See all →",
        viewAllByCategory: {
          cars: "View all cars →",
          motorcycles: "View all motorcycles →",
          classics: "View all classic cars →",
        },
        pinnedLegend: "Pinned listing",
        boostedLegend: "Boosted listing",
        regularLegend: "Regular listing",
        whyTitle: "Why Carva",
        whyCards: [
          {
            title: "Verified Sellers",
            desc: "Every dealer vetted. Private sellers identity-verified before listing.",
          },
          {
            title: "All Vehicle Types",
            desc: "Cars, motorcycles, and classics in one place.",
          },
          {
            title: "Direct WhatsApp",
            desc: "Contact sellers instantly. No middlemen, no hidden fees, ever.",
          },
          {
            title: "Free for Sellers",
            desc: "Private listings are always free. No charges to list your vehicle.",
          },
        ],
        sellTitle: "Ready to sell your vehicle?",
        sellDesc:
          "Cars, motorcycles, and classics — list in under 5 minutes. Reach thousands of verified buyers across Kuwait.",
        sellBtn: "List Your Vehicle →",
        loadingListings: "Loading listings…",
        noLiveInCategory: "No live listings in this category yet.",
        browseCategoryCta: (categoryLabel) => `Browse ${categoryLabel} on the marketplace →`,
        footerCopy: "© 2026 Carva · carvakwt.com",
        footerPrivacy: "Privacy",
        footerTerms: "Terms",
        footerContact: "Contact",
        dealLabels: { great: "Great Deal", good: "Good Deal", fair: "Fair Price" },
        tierPinned: "Featured · Sponsored",
        tierBoosted: "Boosted",
        logoHomeAria: "Carva home",
        categoryTabsLabel: "Vehicle category",
        browseMakeCategoryTabsLabel: "Filter makes by category",
        statsActiveListings: "Active Listings",
        statsVerifiedDealers: "Verified Dealers",
        statsResponseRate: "Response Rate",
        statsAvgRating: "Avg. Rating",
        footerNavPrimary: "Marketplace",
        footerNavLegal: "Legal",
        langLiveEn: "Interface language: English",
        langLiveAr: "واجهة المستخدم: العربية",
      },
      listings: {
        badge: "Kuwait's Vehicle Marketplace",
        title: "Browse Vehicles",
        loading: "Loading…",
        sortLabel: "Sort:",
        selectedCount: (n) => `${n} selected`,
        km: "km",
        specSuffix: "Spec",
        currencyKwd: "KD",
        whatsappInterestMessage: (year, make, model) => `Hi, I'm interested in your ${year} ${make} ${model}`,
        sortFeatured: "Featured first",
        sortLowestPrice: "Lowest Price",
        sortHighestPrice: "Highest Price",
        sortNewest: "Newest",
        sortLowestMileage: "Lowest Mileage",
        priceAny: "Any Price",
        priceUnder5k: "Under 5K",
        price5k15k: "5K – 15K",
        price15k30k: "15K – 30K",
        price30kPlus: "30K+",
        yearAny: "Any Year",
        yearPre1980: "Pre 1980",
        year2023: "2023",
        year2022: "2022",
        year2021: "2021",
        year2020Older: "2020 & older",
        yearClassic: "Classic (pre-1990)",
        allMakes: "All Makes",
        allModels: "Model",
        sellerAll: "All",
        sellerDealer: "Dealerships",
        sellerCarOffice: "Car Offices",
        sellerPrivate: "Private",
        clearFilters: "Clear filters",
        clearAllFilters: "Clear all filters",
        found: (n, categoryLabel) => `${n} ${categoryLabel} found`,
        noMatch: (categoryLabel) => `No ${categoryLabel} match your filters`,
        viewDetails: "View Full Details →",
        save: "Watch",
        whatsapp: "WhatsApp",
        verifiedBadge: "✓ Verified",
        historyTag: "History",
        inspectedTag: "Inspected",
        originalParts: "Original Parts",
        modified: "Modified",
        engineHours: (n) => `${n}h engine hours`,
        listedToday: "Listed today",
        listedYesterday: "Listed yesterday",
        listedDaysAgo: (n) => `Listed ${n} days ago`,
        sellerDealerLine: (name) => `${name}`,
        sellerCarOfficeLine: (name) => `${name}`,
        privateSellerLine: "Private Seller",
        drawerSellerDealer: "Dealership",
        drawerSellerCarOffice: "Car Office",
        drawerSellerPrivate: "Private",
        loadError: "Couldn't load listings. Please try again.",
      },
      signup: {
        typeCarOffice: "Car Office",
        typeCarOfficeDesc:
          "I buy and resell vehicles professionally (مكتب سيارات)",
        typeDealership: "Dealership",
        typeDealershipDesc: "I run an authorized showroom or brand dealership",
        privateDesc: "I want to buy or sell my own personal vehicle",
        step2Dealer: "Tell us about you and your dealership.",
        step2CarOffice: "Tell us about you and your car office.",
        step2Private: "Tell us a bit about yourself.",
        labelDealershipName: "Dealership Name",
        labelCarOfficeName: "Car Office Name",
        placeholderDealership: "e.g. Gulf Motors Kuwait",
        placeholderCarOffice: "e.g. Al Rai Motors",
        errSelectType: "Please select an account type.",
        errFillAll: "Please fill in all fields.",
        errBusinessName: "Please enter your business name.",
        errPasswordMatch: "Passwords don't match.",
        errPasswordShort: "Password must be at least 8 characters.",
        errEmailInUse: "That email is already registered.",
        errGeneric: "Something went wrong.",
        creating: "Creating account...",
        createAccount: "Create Account",
      },
    },
    dashboard: {
      dealerBadge: "Dealer Dashboard",
      carOfficeBadge: "Car Office Dashboard",
      navPortalTitle: "Dealership / Car office dashboard",
      sidebarOverview: "Overview",
      sidebarListings: "Manage Listings",
      sidebarAnalytics: "Analytics",
      sidebarBilling: "Billing",
      sidebarProfile: "Profile",
      sidebarActive: "Active",
      sidebarViews: "Views",
      backToSite: "Back to Site",
      viewSiteLink: "← View Site",
      logOut: "Log Out",
      planCustom: "Custom",
      notSet: "Not set",
      ellipsis: "…",
      billingTitle: "Billing & Subscription",
      billingIntro: "Plan info from your dealer profile. Connect a payment provider to enable renewals and invoices.",
      currentPlan: "Current Plan",
      subscriptionActive: "Your subscription is active.",
      choosePlan: "Choose a plan below to get started.",
      monthly: "Monthly",
      annual: "Annual",
      saveAnnualHint: "Save 20%",
      planBadgeCurrent: "CURRENT PLAN",
      planBadgePopular: "MOST POPULAR",
      perMonth: "KD/mo",
      comingSoon: "Coming soon",
      unlimitedListings: "Unlimited listings",
      listingsCountLine: (n) => `${n} listings`,
      featuredSlotsLine: (n) => `${n} featured slots`,
      planAnalyticsYes: "Analytics dashboard",
      planAnalyticsNo: "Basic stats",
      supportLine: (label) => `${label} support`,
      paymentHistory: "Payment history",
      paymentHistoryEmpty: "No invoices stored yet. When you integrate Stripe or similar, list invoices here.",
      planNameStarter: "Starter",
      planNamePro: "Professional",
      planNameElite: "Elite",
      planSupportEmail: "Email",
      planSupportPriority: "Priority",
      planSupportDedicated: "Dedicated",
      analyticsTitle: "Analytics",
      analyticsCardViews: "Total views (sum on listings)",
      analyticsCardViewsSub: "Stored per listing in Firestore",
      analyticsCardEnquiries: "Enquiries (sum on listings)",
      analyticsCardEnquiriesSub: "Stored per listing in Firestore",
      analyticsCardActive: "Active listings",
      analyticsCardActiveSub: "Your published inventory",
      analyticsCardTraffic: "Traffic sources",
      analyticsCardTrafficSub: "Wire events when you add tracking",
      chartsFunnelsTitle: "Charts & funnels",
      chartsFunnelsBody: "Monthly charts and conversion funnels need aggregated analytics data (e.g. daily rollups in Firestore or an analytics backend). The numbers above come from your listing documents today.",
      manageListingsTitle: "Manage Listings",
      newListing: "+ New Listing",
      searchListingsPlaceholder: "Search listings…",
      colListing: "Listing",
      colPrice: "Price",
      colViews: "Views",
      colLeads: "Leads",
      colStatus: "Status",
      colActions: "Actions",
      featuredInline: "Featured",
      edit: "Edit",
      pause: "Pause",
      activate: "Activate",
      del: "Del",
      noListingsFound: "No listings found",
      deleteListingTitle: "Delete listing?",
      deleteListingBody: "This cannot be undone.",
      filterAll: "All",
      filterActive: "Active",
      filterPaused: "Paused",
      filterPending: "Pending",
      filterSold: "Sold",
      loadingListings: "Loading…",
      cancel: "Cancel",
      greetingMorning: "Good morning",
      greetingAfternoon: "Good afternoon",
      greetingEvening: "Good evening",
      greetingFallbackName: "there",
      loadingDashboard: "…",
      dashboardLoadingHint: "Loading your dashboard…",
      dashboardSubtitle: "Here's how your listings are performing.",
      weeklyTrends: "Weekly trends",
      weeklyTrendsPlaceholder: "Detailed charts will appear here when analytics tracking is enabled for your account.",
      performanceSnapshot: "Performance snapshot",
      perfAvgViews: "Avg. views per listing",
      perfAvgEnquiries: "Avg. enquiries per listing",
      perfActiveListings: "Active listings",
      perfPausedOther: "Paused / other",
      recentListings: "Recent listings",
      viewAllListings: "View all →",
      noListingsYet: "No listings yet. Create one from Sell.",
      viewsCount: (n) => `${n} views`,
      enquiriesCount: (n) => `${n} enquiries`,
      profilePageTitle: "Profile",
      statSubTotalInAccount: (n) => `${n} total in account`,
      statSubSumOnListings: "Sum on your listings",
      statSubAllStatuses: "All statuses",
      statLabelTotalListings: "Total Listings",
    },
    admin: {
      badge: "ADMIN",
      viewSite: "← View Site",
      sidebarDashboard: "Dashboard",
      sidebarListings: "Listings",
      sidebarUsers: "Users",
      sidebarDealers: "Dealers",
      sidebarReports: "Reports",
      reportsTitle: "Reports",
      reportsIntro: "This screen is for user-submitted reports (flagged listings, abuse, etc.). There is no report data wired yet — add a Firestore collection (for example \"reports\") and list open cases here.",
      logOut: "Log Out",
      dashTitle: "Admin Dashboard",
      dashSubtitle: "Platform overview (live from Firestore).",
      statTotalListings: "Total Listings",
      statInDatabase: "In database",
      statRegisteredUsers: "Registered Users",
      statUsersCollection: "users collection",
      statDealerProfiles: "Dealer profiles",
      statDealersCollection: "dealers collection",
      statRevenueMtd: "Revenue (MTD)",
      statConnectBilling: "Connect billing when ready",
      volumeTitle: "Listing volume",
      volumeBody: "Weekly charts can be added when you store aggregated metrics. For now, total listings count is shown above.",
      quickLinksTitle: "Quick links",
      quickReviewListings: "Review listings",
      quickManageDealers: "Manage dealers",
      quickManageUsers: "Manage users",
      recentListingsTitle: "Recent listings",
      loading: "Loading…",
      noListingsFirestore: "No listings in Firestore yet.",
      activityListing: (year, make, model) => `Listing — ${year} ${make} ${model}`,
      activityRecent: "Recently listed",
      listingsTitle: "Manage Listings",
      errLoadListings: "Failed to load listings.",
      errApprove: "Approve failed.",
      errDelete: "Delete failed.",
      errFlag: "Flag failed.",
      colListing: "Listing",
      colSeller: "Seller",
      colPrice: "Price",
      colStatus: "Status",
      colActions: "Actions",
      noListingsMatch: "No listings found",
      listedToday: "Listed today",
      listedDaysAgo: (n) => `Listed ${n} day${n === 1 ? "" : "s"} ago`,
      reported: "Reported",
      btnApprove: "Approve",
      btnReject: "Reject",
      btnFlag: "Flag",
      btnRemove: "Remove",
      btnRestore: "Restore",
      btnDelete: "Delete",
      filterAll: "All",
      filterPending: "Pending",
      filterActive: "Active",
      filterFlagged: "Flagged",
      filterSold: "Sold",
      filterPaused: "Paused",
      filterVerified: "Verified",
      filterDealer: "Dealer",
      filterBanned: "Banned",
      usersTitle: "Manage Users",
      errLoadUsers: "Failed to load users.",
      errBan: "Ban failed.",
      errUnban: "Unban failed.",
      errDeleteUser: "Delete failed.",
      colUser: "User",
      colType: "Type",
      colRole: "Role",
      colJoined: "Joined",
      noUsersFound: "No users found",
      searchPlaceholder: "Search…",
      btnEmail: "Email",
      btnBan: "Ban",
      btnUnban: "Unban",
      dealersTitle: "Manage Dealers",
      statTotalDealers: "Total Dealers",
      statDealersInCollection: "In dealers collection",
      statMonthlyRevenue: "Monthly Revenue",
      statPendingVerification: "Pending verification",
      statNotVerifiedYet: "Not yet verified",
      colDealer: "Dealer",
      colPlan: "Plan",
      colListings: "Listings",
      colRevenue: "Revenue",
      noDealersFound: "No dealers found",
      dealerSince: (joined) => `since ${joined}`,
      btnView: "View",
      reportsLoadFailed: "Failed to load reports.",
      reportsColIssue: "Issue",
      reportsColListing: "Listing",
      reportsColStatus: "Status",
      reportsColActions: "Actions",
      reportsNoReports: "No reports found.",
      btnResolve: "Resolve",
      btnViewAd: "View Ad",
      reportStatusOpen: "Open",
      reportStatusResolved: "Resolved",
      dashLoadingEllipsis: "…",
    },
    home: {
      badge: "Kuwait's Premium Car Marketplace",
      h1a: "The Smarter Way",
      h1b: "to Buy & Sell Cars",
      subtitle: "Verified listings, transparent pricing, and direct WhatsApp contact. No ads, no noise.",
      browseCars: "Browse Cars →",
      listYourCar: "List Your Car",
      statsLabels: ["Active Listings", "Verified Dealers", "GCC Spec Cars", "Listing Review"],
      browseByMake: "Browse by Make",
      viewAll: "View all →",
      featuredListings: "Featured Listings",
      seeAll: "See all listings →",
      whyCarva: "Why Carva",
      trust: [
        { title: "Verified Sellers", desc: "Every dealer is vetted. Private sellers go through identity verification before listing." },
        { title: "Vehicle History", desc: "Full accident, ownership, and service history reports available on every listing." },
        { title: "Direct WhatsApp", desc: "Contact sellers instantly via WhatsApp — no middlemen, no hidden fees, no delays." },
      ],
      sellTitle: "Ready to sell your car?",
      sellDesc: "List in under 5 minutes. Reach thousands of verified buyers across Kuwait.",
      sellBtn: "List Your Car →",
      footerCopy: "© 2025 Carva. Kuwait's Premium Car Marketplace.",
      footerLinks: ["Privacy", "Terms", "Contact"],
      dealLabels: { great: "Great Deal", good: "Good Deal", fair: "Fair Price" },
    },
    listings: {
      badge: "Kuwait's Premium Car Marketplace",
      title: "Find Your Car",
      statsLabels: ["Listings", "Dealers", "Verified"],
      allMakes: "All Makes",
      allModels: "All Models",
      anyYear: "Any Year",
      anyPrice: "Any Price",
      sellerAll: "All",
      sellerDealer: "Dealers",
      sellerPrivate: "Private",
      sort: "Sort:",
      carsAvailable: n => `${n} cars available`,
      clearFilters: "Clear filters",
      loading: "Loading listings...",
      noMatch: "No cars match your filters",
      clearAll: "Clear all filters",
      whatsapp: "WhatsApp",
      privateSeller: "Private Seller",
      listedToday: "Listed today",
      listedYesterday: "Listed yesterday",
      listedDaysAgo: n => `Listed ${n} days ago`,
      dealLabels: { great: "Great Deal", good: "Good Deal", fair: "Fair Price" },
      tabOverview: "overview",
      tabDetails: "details",
      tabMarket: "market",
      mileage: "Mileage",
      fuel: "Fuel",
      transmission: "Transmission",
      specification: "Specification",
      color: "Color",
      seller: "Seller",
      priceAnalysis: "Price Analysis",
      avgMarket: "Avg. Market",
      thisListing: "This Listing",
      saving: "Saving",
      contactWhatsApp: "Contact on WhatsApp",
      save: "Watch",
      verified: "Verified",
      history: "History Report",
      inspected: "Inspected",
    },
    car: {
      loading: "Loading...",
      notFound: "Listing not found",
      loadError: "Could not load this listing. Please try again.",
      backToListings: "Back to Listings",
      breadcrumb: "Listings",
      specifications: "Specifications",
      sellerNotes: "Seller Notes",
      marketIntel: "Market Intelligence",
      similarListings: "Similar Listings",
      specLabels: {
        Make: "Make", Model: "Model", Year: "Year", Trim: "Trim",
        Mileage: "Mileage", Fuel: "Fuel", Transmission: "Transmission",
        Color: "Color", Specification: "Specification", Condition: "Condition",
      },
      privateSeller: "Private Seller",
      listedToday: "today",
      listedYesterday: "yesterday",
      listedDaysAgo: n => `${n} days ago`,
      listedPrefix: "Listed",
      avgMarket: "Avg. Market",
      thisListing: "This Listing",
      youSave: "You Save",
      contactWhatsApp: "Contact on WhatsApp",
      save: "Watch",
      share: "Share",
      shareLinkCopied: "Link copied to clipboard",
      saved: "Watched",
      km: "km",
      specSuffix: "Spec",
      currencyKwd: "KD",
      history: "History",
      inspected: "Inspected",
      whatsappInterestMessage: (year, make, model) => `Hi, I'm interested in your ${year} ${make} ${model}`,
      views: "views",
      verified: "Verified",
      dealSignal: "Deal signal",
      report: "Report",
      reportTitle: "Report this ad",
      reportSubtitle: "Tell us what issue you found.",
      reportPlaceholder: "Describe the issue...",
      reportSubmitted: "Report submitted. Thank you.",
      reportFailed: "Failed to submit report.",
      submitReport: "Submit Report",
      submitting: "Submitting...",
      cancel: "Cancel",
      marketIntelText: (dealLabel, make, model) => `Indicative ranges vary by condition and options. This listing is labeled a ${dealLabel} for its year and mileage. For a precise market picture, compare similar ${make} ${model} listings live on Carva.`,
      dealLabels: { great: "Great Deal", good: "Good Deal", fair: "Fair Price" },
      marketMedian: "Market median",
      marketIntelNotEnough: "Not enough comparable listings yet — deal signal updates automatically as more listings are added.",
      marketIntelBasedOn: (count, make, model) => `Based on ${count} similar ${make} ${model} listings on Carva`,
      mileageVsAverageBelow: (km) => `Mileage is ${km.toLocaleString()} km below average for this model`,
      mileageVsAverageAbove: (km) => `Mileage is ${km.toLocaleString()} km above average for this model`,
      mileageVsAverageMatch: "Mileage is close to the average for this model",
      priceVsComparables: "Price vs comparables",
    },
    dealers: {
      badge: "Kuwait's Verified Dealers",
      title: "Find a Dealer",
      statsValues: ["340+", "98%", "GCC"],
      statsLabels: ["Dealers", "Verified", "Specialists"],
      searchPlaceholder: "Search dealer name or brand...",
      specialties: ["All", "Luxury & Performance", "German Specialists", "Japanese & Korean", "American & SUV", "Ultra Luxury", "Multi-Brand"],
      dealersFound: n => `${n} dealers found`,
      listings: "Listings",
      since: "Since",
      response: "Response",
      whatsapp: "WhatsApp",
      viewShowroom: "View Showroom →",
    },
    dealerProfile: {
      since: "Since",
      responds: "Responds",
      active: "Active",
      sold: "Sold",
      activeCars: "cars",
      whatsapp: "WhatsApp Dealer",
      noListings: "No listings found for this dealer yet.",
      loading: "Loading listings...",
      notFound: "Dealer not found",
      backToDealers: "Back to Dealers",
      listings: n => `${n} Active Listing${n !== 1 ? "s" : ""}`,
    },
    sell: {
      navTitle: "List Your Car",
      saveDraft: "Save Draft",
      steps: ["Car Details", "Specs & Price", "Photos", "Contact & Preview"],
      step0Title: "Car Details",
      step0Sub: "Tell us about the car you're selling.",
      categoryLabel: "Category",
      draftSaved: "Draft saved. You can continue later.",
      draftRestored: "Draft restored from your last session.",
      draftSaveFailed: "Couldn't save draft. Please try again.",
      draftSavedToAccount: "Draft saved to your account listings.",
      make: "Make", model: "Model", year: "Year",
      trimLabel: "Trim / Variant", colorLabel: "Color", specLabel: "Specification",
      selectMake: "Select make", selectModel: "Select model", selectYear: "Select year",
      trimPlaceholder: "e.g. S Line, AMG, VXR",
      selectColor: "Select color", selectSpec: "Select spec",
      step1Title: "Specs & Price",
      step1Sub: "Help buyers understand the car's condition and value.",
      fuel: "Fuel Type", trans: "Transmission", mileage: "Mileage (km)", condition: "Condition",
      price: "Asking Price (KD)", dealQuestion: "How would you describe this deal?",
      selectFuel: "Select fuel", selectTrans: "Select transmission",
      mileagePlaceholder: "e.g. 45000", selectCondition: "Select condition",
      pricePlaceholder: "e.g. 12500",
      dealPreviewFootnote: "Deal tier is estimated automatically from live listings once yours is active — you don’t pick it here.",
      publishErrorMissingMakeModel: "Choose a make and model before publishing.",
      publishErrorInvalidYear: "Choose a valid model year. For classics before 1980, pick “Pre 1980”.",
      publishErrorInvalidPrice: "Enter a valid asking price (numbers only).",
      publishErrorInvalidMileage: "Enter a valid mileage (numbers only).",
      publishErrorNeedPhotos: "Add at least one photo before publishing.",
      submitErrorUnauthenticated: "You must be signed in to publish. Try logging in again.",
      submitErrorRateLimited: "You’ve submitted several listings in the last hour. Please wait a bit and try again.",
      submitErrorPermissionDenied: "You don’t have permission to complete this action.",
      submitErrorNotFound: "That draft or listing could not be found. Refresh and try again.",
      submitErrorTooManyImages: "Too many images. Remove some photos and try again.",
      submitErrorInvalidImages: "One or more image links were rejected. Try re-uploading your photos.",
      submitErrorMissingFields: "Some required details are missing or invalid. Check make, model, year, price, and photos.",
      submitErrorInvalidArgument: "The server couldn’t accept this submission. Check your details and try again.",
      submitErrorGeneric: "Something went wrong while publishing. Please try again.",
      submitErrorUploadBlocked: (uid) =>
        `Upload blocked: check Firebase Storage rules allow authenticated writes to listings/${uid}.`,
      dealOptions: [
        { label: "Great Deal", hint: "Price below market" },
        { label: "Good Deal", hint: "Slightly below market" },
        { label: "Fair Price", hint: "At market value" },
      ],
      step2Title: "Photos",
      step2Sub: "Listings with more photos get 3× more enquiries. The first photo becomes the cover.",
      dropText: "Drop photos here or click to upload",
      dropHint: "Up to 10 photos · JPG, PNG · Max 10MB each",
      cover: "Cover",
      photosAdded: n => `${n} photo${n !== 1 ? "s" : ""} added`,
      remaining: n => `${n} remaining`,
      step3Title: "Contact & Preview",
      step3Sub: "Buyers will reach you directly on WhatsApp.",
      businessNameLabel: "Business Name",
      yourName: "Your Name", whatsappNum: "WhatsApp Number", notesLabel: "Additional Notes",
      namePlaceholder: "e.g. Ahmed Al-Rashidi",
      whatsappPlaceholder: "e.g. 96599887766",
      whatsappHelper: "This is the number buyers will use to contact you. Update it in your profile if needed.",
      notesPlaceholder: "Anything buyers should know — service history, recent repairs, reason for selling...",
      termsText: "By submitting, you confirm the listing is accurate and agree to Carva's",
      termsLink: "terms of service",
      termsEnd: ". Listings are reviewed within 2 hours.",
      back: "← Back",
      continue: "Continue →",
      publishing: "Publishing...",
      publish: "Publish Listing",
      livePreview: "Live Preview",
      previewDesc: "This is how your listing will appear to buyers",
      listingStrength: "Listing Strength",
      strengthItems: ["Car Details", "Specs & Price", "Photos", "Contact Info"],
      complete: n => `${n}% complete`,
      successTitle: "Listing Submitted!",
      successDesc: "Your car has been submitted for review. We'll notify you once it's live — usually within 2 hours.",
      successTitleDealer: "Listing Published!",
      successDescDealer: "Your listing is now live and visible to buyers.",
      listAnother: "List Another Car",
      backToDashboard: "Back to Dashboard",
      backToHome: "Back to Home Page",
      limitedEditNavTitle: "Update listing",
      limitedEditTitle: "Update your listing",
      limitedEditSub: "You can only change mileage, asking price, photos, and additional notes. Everything else stays as on file.",
      limitedEditBannerLive: "This listing is live. Saving applies your changes immediately.",
      limitedEditBannerPaused: "This listing is paused. You can update details; pause stays on until you activate it from My Listings.",
      limitedEditBannerPending: "This listing is still awaiting review. You can adjust these fields; it will remain in review.",
      saveListingChangesLive: "Save changes",
      saveListingChangesPending: "Save updates",
      savingChanges: "Saving…",
      successUpdatedTitle: "Changes saved",
      successUpdatedDesc: "Your listing has been updated and is visible to buyers with your new details.",
      successUpdatedPendingDesc: "Your updates were saved. The listing is still pending review.",
      backToMyListings: "Back to My Listings",
      editListingNotFound: "We could not find this listing.",
      editListingNotOwner: "You can only edit your own listings.",
      editListingNotEditable: "This listing cannot be edited here (for example it may be sold or removed).",
      editListingLoadFailed: "Could not load this listing. Try again.",
      editListingLoading: "Loading listing…",
      partialSaveInvalidNumbers: "Enter valid numbers for mileage and price.",
      limitedStrengthMileagePrice: "Mileage & price",
      limitedStrengthPhotos: "Photos",
    },
    account: {
      profile: "Profile",
      myListings: "My Listings",
      signOut: "Sign Out",
      privateSeller: "Private Seller",
      carDealer: "Car Dealer",
      editProfile: "Edit Profile",
      profileSub: "Update your personal information.",
      fullName: "Full Name",
      whatsapp: "WhatsApp Number",
      email: "Email Address",
      emailNote: "Email address cannot be changed.",
      saveChanges: "Save Changes",
      saving: "Saving...",
      changesSaved: "Saved ✓",
      myListingsTitle: "My Listings",
      myListingsSub: "Cars you've listed on Carva.",
      noListings: "You haven't listed any cars yet.",
      listACar: "List a Car →",
      loading: "Loading...",
      savedTitle: "Watched Ads",
      savedSub: "Ads you're watching for later.",
      noSaved: "No watched ads yet.",
      browseCars: "Browse Cars →",
      carOffice: "Car Office",
      removeFromSaved: "Remove from watched",
      saved: "Watched",
      savedYesterday: "Watched yesterday",
      savedDaysAgo: (n) => `Watched ${n} days ago`,
      savedCount: (n) => `${n} ad${n !== 1 ? "s" : ""} watched`,
      clearAll: "Clear all",
      loadingSavedCars: "Loading watched ads…",
      savedHint: "Tap the watch button on any listing to add it here",
      cancel: "Cancel",
      delete: "Delete",
      deleteListingTitle: "Delete Listing",
      deleteListingMessage: "This will permanently remove the listing. This action cannot be undone.",
      activeListings: "Active Listings",
      totalViews: "Total Views",
      totalEnquiries: "Total Enquiries",
      enquiries: "enquiries",
      filterAll: "All",
      statusActive: "Active",
      statusDraft: "Draft",
      statusPaused: "Paused",
      statusSold: "Sold",
      newListing: "+ New Listing",
      loadingListings: "Loading listings…",
      noListingsForFilter: (f) => `No ${f === "All" ? "" : `${f.toLowerCase()} `}listings`,
      postFirstCar: "+ Post your first car",
      listedDaysAgo: (n) => `Listed ${n} days ago`,
      resume: "Resume",
      edit: "Edit",
      pause: "Pause",
      activate: "Activate",
      couldNotLoadProfile: "Could not load profile",
      saveFailed: "Save failed",
      loadingProfile: "Loading profile…",
      profileInformation: "Profile Information",
      profileInfoHint: "This is how buyers will see you on listings.",
      profilePhoto: "Profile photo",
      fullNamePlaceholder: "Your full name",
      whatsappPlaceholder: "e.g. 96599887766",
      whatsappHint: "Buyers contact you on this number",
      emailManagedHint: "Email is managed by your login provider",
      location: "Location",
      locationPlaceholder: "e.g. Kuwait City",
      bio: "Bio",
      optional: "optional",
      bioPlaceholder: "Tell buyers a bit about yourself...",
      password: "Password",
      passwordHint: "Change your account password.",
      changePassword: "Change Password",
      currentPassword: "Current Password",
      currentPasswordPlaceholder: "Enter current password",
      newPassword: "New Password",
      newPasswordPlaceholder: "Create new password",
      confirmNewPassword: "Confirm New Password",
      confirmNewPasswordPlaceholder: "Repeat new password",
      updatePassword: "Update Password",
      passwordFillAll: "Please fill in all password fields.",
      passwordMismatch: "New password and confirmation do not match.",
      passwordTooShort: "Password must be at least 6 characters.",
      passwordWrongCurrent: "Current password is incorrect.",
      passwordUpdated: "Password updated successfully.",
      passwordUpdateFailed: "Failed to update password. Please try again.",
      passwordProviderUnsupported: "Password change is not available for this login method.",
      permanentlyDeleteAccount: "Permanently Delete Account",
      deleteAccountHint: "Permanently delete your account and all your listings. This cannot be undone.",
      deleteAccount: "Delete Account",
      deleting: "Deleting...",
      deleteConfirm: "Permanently delete your account? This will remove your profile and all your listings.",
      reloginToDelete: "For security, please log in again and retry deleting your account.",
      deleteFailed: "Failed to delete account.",
      featured: "Featured",
      highlighted: "Boost",
      refresh: "Refresh",
      refreshed: "Refreshed",
      featured7d: "Featured (7d)",
      highlighted7d: "Boost (7d)",
      refreshOneTime: "Refresh (1x)",
      featured7dDesc: "Priority in matching default results for 7 days, plus rotating homepage eligibility. No guaranteed first position.",
      highlighted7dDesc: "Boost styling and stronger visibility for 7 days.",
      refreshOneTimeDesc: "Move this listing back to top once.",
      processing: "Processing...",
      payAndActivate: "Pay & Activate",
      featureHowItWorks: "How it works",
      duration7Days: "7 days",
      durationOneTime: "1 time",
      paidFeatureUnavailable: "Paid boosts are not available yet.",
      paidFeatureErrorGeneric: "Could not apply boost. Try again, or confirm Cloud Functions are deployed.",
      paidFeatureErrorRefreshUsed: "Refresh was already used for this listing.",
      paidFeatureErrorNotFound: "Listing not found.",
      paidFeatureErrorPermission: "You can only boost your own listings.",
      paidFeatureErrorSignIn: "Please sign in again to continue.",
    },
    auth: {
      login: {
        title: "Log in to Carva",
        subtitle: "Welcome back — your cars are waiting",
        noAccount: "Don't have an account?",
        signUp: "Sign up",
        emailLabel: "Email",
        passwordLabel: "Password",
        emailPlaceholder: "you@example.com",
        passwordPlaceholder: "Enter your password",
        forgotPassword: "Forgot password?",
        logIn: "Log In",
        loggingIn: "Logging in...",
        orContinueWith: "or continue with",
        continueWithGoogle: "Continue with Google",
        noAccountFull: "Don't have an account?",
        signUpFree: "Sign up free",
        fillAll: "Please fill in all fields.",
        show: "Show",
        hide: "Hide",
      },
      signup: {
        alreadyHave: "Already have an account?",
        logIn: "Log in",
        step1Title: "Create your account",
        step1Subtitle: "What best describes you?",
        privateSeller: "Private Seller",
        privateDesc: "I want to buy or sell my personal car",
        carDealer: "Car Dealer",
        dealerDesc: "I run a dealership and want to list multiple cars",
        continue: "Continue →",
        step2Title: "Your details",
        step2SubtitleDealer: "Tell us about you and your dealership.",
        step2SubtitlePrivate: "Tell us a bit about yourself.",
        fullName: "Full Name",
        dealershipName: "Dealership Name",
        whatsapp: "WhatsApp Number",
        emailAddress: "Email Address",
        namePlaceholder: "e.g. Ahmed Al-Rashidi",
        dealerPlaceholder: "e.g. Gulf Motors Kuwait",
        whatsappPlaceholder: "e.g. 96599887766",
        emailPlaceholder: "you@example.com",
        back: "← Back",
        step3Title: "Set a password",
        step3Subtitle: "At least 8 characters.",
        password: "Password",
        confirmPassword: "Confirm Password",
        passwordPlaceholder: "Create a password",
        confirmPlaceholder: "Repeat your password",
        strengthWeak: "Weak",
        strengthGood: "Good",
        strengthStrong: "Strong",
        terms: "By signing up you agree to Carva's",
        termsLink: "Terms of Service",
        and: "and",
        privacyLink: "Privacy Policy",
        createAccount: "Create Account",
        creating: "Creating account...",
        fillAll: "Please fill in all fields.",
        selectType: "Please select an account type.",
        passwordMismatch: "Passwords don't match.",
        passwordShort: "Password must be at least 8 characters.",
        doneTitle: "Account Created!",
        doneWelcome: n => `Welcome to Carva, ${n}.`,
        doneVerify: "Check your email to verify your account.",
        startBrowsing: "Start Browsing →",
        show: "Show",
        hide: "Hide",
      },
      forgot: {
        backToLogin: "← Back to login",
        formTitle: "Forgot your password?",
        formSubtitle: "No worries. Enter your email and we'll send you a reset link.",
        emailLabel: "Email Address",
        emailPlaceholder: "you@example.com",
        sendLink: "Send Reset Link",
        sending: "Sending...",
        sentTitle: "Check your inbox",
        sentDesc: "We sent a password reset link to",
        didntGet: "Didn't get it? Check your spam folder or try again in a few minutes.",
        tryDifferent: "Try a different email",
        backToLoginBtn: "Back to Login",
        rememberedIt: "Remembered it?",
        enterEmail: "Please enter your email address.",
        validEmail: "Please enter a valid email address.",
      },
    },
  },

  ar: {
    market: {"noOptions":"لا توجد خيارات مطابقة","filtersSort":"التصفية والترتيب","showResults":"عرض النتائج","loadMore":"عرض المزيد من المركبات","removeFilter":"إزالة الفلتر","loadError":"ما قدرنا نحمّل المركبات. جرّب مرة ثانية.","retry":"جرّب مرة ثانية"},
    nav: {
      listNow: "أضف إعلانك",
      home: "الرئيسية",
      openMenu: "افتح القائمة",
      closeMenu: "إغلاق القائمة",
      menu: "القائمة",
      navigation: "التنقل الرئيسي",
      language: "اللغة",
      appearance: "المظهر",
      light: "فاتح",
      dark: "داكن",
      buy: "تصفح المركبات",
      sell: "بيع",
      dealers: "المعارض",
      about: "من نحن",
      listCar: "أضف إعلانك",
      listVehicle: "أضف إعلانك",
      listVehicleShort: "أضف إعلانك",
      logIn: "تسجيل الدخول",
      myAccount: "حسابي",
      myDashboard: "لوحة التحكم",
    },
    common: {
      loading: "جاري التحميل…",
      testingEnvironment: "بيئة اختبار — بيانات تجريبية",
    },
    notFound: {
      code: "404",
      title: "الصفحة غير موجودة",
      body: "الصفحة التي تبحث عنها غير موجودة أو تم نقلها.",
      cta: "العودة للرئيسية",
    },
    logout: {
      signingOut: "جاري تسجيل الخروج…",
    },
    errors: {
      boundaryTitle: "حدث خطأ",
      boundaryBody: "حدث خطأ غير متوقع. يرجى تحديث الصفحة والمحاولة مرة أخرى.",
      refresh: "تحديث الصفحة",
    },
    carva: {
      categories: {
        cars: "سيارات",
        motorcycles: "دراجات نارية",
        classics: "سيارات كلاسيكية",
      },
      home: {
        listHint: "أضف تفاصيل مركبتك وصورها",
        badge: "سوق المركبات المميز في الكويت",
        heroTitle1: "تبي تبيع أو تشتري؟",
        heroTitle2: "",
        heroSubtitle:
          "سيارات، دراجات وكلاسيك في الكويت. تواصل مع البائع مباشرة.",
        browsePrefix: "تصفح",
        browseArrow: "←",
        searchPlaceholder: "الماركة، الموديل، أو كلمة تبحث عنها",
        searchButton: "بحث",
        featuredPinnedTitle: "مميز — اختيارات مثبتة",
        latestTitle: "أحدث الإعلانات",
        footerGuides: "أدلة",
        footerHelp: "مساعدة",
        footerDealers: "وكلاء مميزون",
        browseByMake: "تصفح حسب الماركة",
        browseByMakeSub: "ابحث عن ماركتك المفضلة",
        featuredLine: "مميز",
        seeAll: "عرض الكل ←",
        viewAllByCategory: {
          cars: "عرض كل السيارات ←",
          motorcycles: "عرض كل الدراجات النارية ←",
          classics: "عرض كل السيارات الكلاسيكية ←",
        },
        pinnedLegend: "إعلان مثبّت",
        boostedLegend: "إعلان مُعزّز",
        regularLegend: "إعلان عادي",
        whyTitle: "لماذا كارفا",
        whyCards: [
          {
            title: "بائعون موثقون",
            desc: "كل وكيل تم التحقق منه. البائعون الخاصون يُتحقق من هويتهم قبل النشر.",
          },
          {
            title: "كل أنواع المركبات",
            desc: "سيارات ودراجات وكلاسيك في مكان واحد.",
          },
          {
            title: "واتساب مباشر",
            desc: "تواصل مع البائعين فوراً. بلا وسطاء ولا رسوم خفية.",
          },
          {
            title: "مجاني للبائعين",
            desc: "الإعلانات الخاصة مجانية دائماً.",
          },
        ],
        sellTitle: "جاهز لبيع مركبتك؟",
        sellDesc:
          "سيارات ودراجات وكلاسيك — أضف إعلانك في أقل من 5 دقائق ووصّل لآلاف المشترين.",
        sellBtn: "أضف مركبتك ←",
        loadingListings: "جاري تحميل الإعلانات…",
        noLiveInCategory: "ما فيه إعلانات بهالفئة للحين.",
        browseCategoryCta: (categoryLabel) => `تصفح ${categoryLabel} في السوق ←`,
        footerCopy: "© 2026 كارفا · carvakwt.com",
        footerPrivacy: "الخصوصية",
        footerTerms: "الشروط",
        footerContact: "تواصل",
        dealLabels: { great: "سعر ممتاز", good: "سعر جيد", fair: "سعر عادل" },
        tierPinned: "مميز · إعلان ممول",
        tierBoosted: "مُعزّز",
        logoHomeAria: "الرئيسية كارفا",
        categoryTabsLabel: "فئة المركبة",
        browseMakeCategoryTabsLabel: "تصفية الماركات حسب الفئة",
        statsActiveListings: "إعلانات نشطة",
        statsVerifiedDealers: "وكلاء موثقون",
        statsResponseRate: "معدل الرد",
        statsAvgRating: "متوسط التقييم",
        footerNavPrimary: "السوق",
        footerNavLegal: "قانوني",
        langLiveEn: "واجهة المستخدم: الإنجليزية",
        langLiveAr: "واجهة المستخدم: العربية",
      },
      listings: {
        badge: "سوق المركبات في الكويت",
        title: "تصفح المركبات",
        loading: "جاري التحميل…",
        sortLabel: "ترتيب:",
        selectedCount: (n) => `${n} مختار`,
        km: "كم",
        specSuffix: "المواصفات",
        currencyKwd: "د.ك",
        whatsappInterestMessage: (year, make, model) => `مرحبا، أنا مهتم بـ ${year} ${make} ${model}`,
        sortFeatured: "المميزة أولاً",
        sortLowestPrice: "الأقل سعراً",
        sortHighestPrice: "الأعلى سعراً",
        sortNewest: "الأحدث",
        sortLowestMileage: "أقل مسافة",
        priceAny: "أي سعر",
        priceUnder5k: "أقل من 5K",
        price5k15k: "5K – 15K",
        price15k30k: "15K – 30K",
        price30kPlus: "30K+",
        yearAny: "أي سنة",
        yearPre1980: "قبل 1980",
        year2023: "2023",
        year2022: "2022",
        year2021: "2021",
        year2020Older: "2020 وأقدم",
        yearClassic: "كلاسيك (قبل 1990)",
        allMakes: "كل الماركات",
        allModels: "الموديل",
        sellerAll: "الكل",
        sellerDealer: "وكلاء",
        sellerCarOffice: "مكاتب سيارات",
        sellerPrivate: "خاص",
        clearFilters: "مسح الفلاتر",
        clearAllFilters: "مسح كل الفلاتر",
        found: (n, categoryLabel) => `${n} ${categoryLabel} متاحة`,
        noMatch: (categoryLabel) => `لا توجد ${categoryLabel} تطابق الفلاتر`,
        viewDetails: "عرض التفاصيل الكاملة ←",
        save: "تابع",
        whatsapp: "واتساب",
        verifiedBadge: "✓ موثّق",
        historyTag: "سجل",
        inspectedTag: "مُفحوص",
        originalParts: "قطع أصلية",
        modified: "معدّل",
        engineHours: (n) => `${n} ساعة محرك`,
        listedToday: "أُدرج اليوم",
        listedYesterday: "أُدرج أمس",
        listedDaysAgo: (n) => `أُدرج منذ ${n} يوماً`,
        sellerDealerLine: (name) => `${name}`,
        sellerCarOfficeLine: (name) => `${name}`,
        privateSellerLine: "بائع خاص",
        drawerSellerDealer: "وكالة",
        drawerSellerCarOffice: "مكتب سيارات",
        drawerSellerPrivate: "خاص",
        loadError: "تعذّر تحميل الإعلانات. حاول مرة أخرى.",
      },
      signup: {
        typeCarOffice: "مكتب سيارات",
        typeCarOfficeDesc: "أشتري وأبيع المركبات بشكل مهني (مكتب سيارات)",
        typeDealership: "معرض / وكالة",
        typeDealershipDesc: "أدير معرضاً معتمداً أو وكالة علامة",
        privateDesc: "أريد شراء أو بيع مركبتي الشخصية",
        step2Dealer: "أخبرنا عنك وعن معرضك.",
        step2CarOffice: "أخبرنا عنك ومكتبك.",
        step2Private: "أخبرنا قليلاً عن نفسك.",
        labelDealershipName: "اسم المعرض",
        labelCarOfficeName: "اسم المكتب",
        placeholderDealership: "مثال: معرض الخليج الكويت",
        placeholderCarOffice: "مثال: معرض الراي",
        errSelectType: "يرجى اختيار نوع الحساب.",
        errFillAll: "يرجى ملء جميع الحقول.",
        errBusinessName: "يرجى إدخال اسم النشاط.",
        errPasswordMatch: "كلمتا المرور غير متطابقتين.",
        errPasswordShort: "كلمة المرور 8 أحرف على الأقل.",
        errEmailInUse: "هذا البريد مسجل مسبقاً.",
        errGeneric: "حدث خطأ ما.",
        creating: "جاري إنشاء الحساب...",
        createAccount: "إنشاء الحساب",
      },
    },
    dashboard: {
      dealerBadge: "لوحة الوكيل",
      carOfficeBadge: "لوحة مكتب السيارات",
      navPortalTitle: "لوحة الوكيل / مكتب السيارات",
      sidebarOverview: "نظرة عامة",
      sidebarListings: "إدارة الإعلانات",
      sidebarAnalytics: "التحليلات",
      sidebarBilling: "الفوترة",
      sidebarProfile: "الملف الشخصي",
      sidebarActive: "نشط",
      sidebarViews: "مشاهدات",
      backToSite: "العودة للموقع",
      viewSiteLink: "عرض الموقع ←",
      logOut: "تسجيل الخروج",
      planCustom: "مخصص",
      notSet: "غير محدد",
      ellipsis: "…",
      billingTitle: "الفوترة والاشتراك",
      billingIntro: "معلومات الخطة من ملف الوكيل. اربط مزود دفع لتفعيل التجديد والفواتير.",
      currentPlan: "الخطة الحالية",
      subscriptionActive: "اشتراكك نشط.",
      choosePlan: "اختر خطة أدناه للبدء.",
      monthly: "شهري",
      annual: "سنوي",
      saveAnnualHint: "وفر 20٪",
      planBadgeCurrent: "الخطة الحالية",
      planBadgePopular: "الأكثر شعبية",
      perMonth: "د.ك/شهر",
      comingSoon: "قريباً",
      unlimitedListings: "إعلانات غير محدودة",
      listingsCountLine: (n) => `${n} إعلانات`,
      featuredSlotsLine: (n) => `${n} أماكن تمييز`,
      planAnalyticsYes: "لوحة تحليلات",
      planAnalyticsNo: "إحصائيات أساسية",
      supportLine: (label) => `دعم ${label}`,
      paymentHistory: "سجل المدفوعات",
      paymentHistoryEmpty: "لا توجد فواتير بعد. عند ربط Stripe أو ما شابه، اعرض الفواتير هنا.",
      planNameStarter: "مبتدئ",
      planNamePro: "احترافي",
      planNameElite: "نخبة",
      planSupportEmail: "بريد",
      planSupportPriority: "أولوية",
      planSupportDedicated: "مخصص",
      analyticsTitle: "التحليلات",
      analyticsCardViews: "إجمالي المشاهدات (مجموع الإعلانات)",
      analyticsCardViewsSub: "مخزّن في كل إعلان في Firestore",
      analyticsCardEnquiries: "الاستفسارات (مجموع الإعلانات)",
      analyticsCardEnquiriesSub: "مخزّن في كل إعلان في Firestore",
      analyticsCardActive: "الإعلانات النشطة",
      analyticsCardActiveSub: "مخزونك المنشور",
      analyticsCardTraffic: "مصادر الزيارات",
      analyticsCardTrafficSub: "فعّل التتبع عند الإضافة",
      chartsFunnelsTitle: "الرسوم والمسارات",
      chartsFunnelsBody: "الرسوم الشهرية ومسارات التحويل تحتاج بيانات مجمّعة (مثل تجميع يومي في Firestore أو خادم تحليلات). الأرقام أعلاه من مستندات إعلاناتك حالياً.",
      manageListingsTitle: "إدارة الإعلانات",
      newListing: "+ إعلان جديد",
      searchListingsPlaceholder: "ابحث في الإعلانات…",
      colListing: "الإعلان",
      colPrice: "السعر",
      colViews: "المشاهدات",
      colLeads: "العروض",
      colStatus: "الحالة",
      colActions: "إجراءات",
      featuredInline: "مميز",
      edit: "تعديل",
      pause: "إيقاف",
      activate: "تفعيل",
      del: "حذف",
      noListingsFound: "لا توجد إعلانات",
      deleteListingTitle: "حذف الإعلان؟",
      deleteListingBody: "لا يمكن التراجع عن ذلك.",
      filterAll: "الكل",
      filterActive: "نشط",
      filterPaused: "موقوف",
      filterPending: "قيد المراجعة",
      filterSold: "مباع",
      loadingListings: "جاري التحميل…",
      cancel: "إلغاء",
      greetingMorning: "صباح الخير",
      greetingAfternoon: "مساء الخير",
      greetingEvening: "مساء الخير",
      greetingFallbackName: "معك",
      loadingDashboard: "…",
      dashboardLoadingHint: "جاري تحميل لوحتك…",
      dashboardSubtitle: "هذه أداء إعلاناتك.",
      weeklyTrends: "الاتجاهات الأسبوعية",
      weeklyTrendsPlaceholder: "ستظهر الرسوم هنا عند تفعيل تتبع التحليلات لحسابك.",
      performanceSnapshot: "لمحة الأداء",
      perfAvgViews: "متوسط المشاهدات لكل إعلان",
      perfAvgEnquiries: "متوسط الاستفسارات لكل إعلان",
      perfActiveListings: "الإعلانات النشطة",
      perfPausedOther: "موقوفة / أخرى",
      recentListings: "أحدث الإعلانات",
      viewAllListings: "عرض الكل ←",
      noListingsYet: "لا إعلانات بعد. أنشئ واحداً من بيع.",
      viewsCount: (n) => `${n} مشاهدة`,
      enquiriesCount: (n) => `${n} استفسار`,
      profilePageTitle: "الملف الشخصي",
      statSubTotalInAccount: (n) => `${n} إجمالي في الحساب`,
      statSubSumOnListings: "مجموع على إعلاناتك",
      statSubAllStatuses: "كل الحالات",
      statLabelTotalListings: "إجمالي الإعلانات",
    },
    admin: {
      badge: "إدارة",
      viewSite: "عرض الموقع ←",
      sidebarDashboard: "لوحة التحكم",
      sidebarListings: "الإعلانات",
      sidebarUsers: "المستخدمون",
      sidebarDealers: "الوكلاء",
      sidebarReports: "التقارير",
      reportsTitle: "التقارير",
      reportsIntro: "هذه الصفحة مخصصة لتقارير المستخدمين (إعلانات مشبوهة، إساءة، إلخ). لا توجد بيانات متصلة بعد — أضف مجموعة في Firestore (مثل \"reports\") واعرض الحالات المفتوحة هنا.",
      logOut: "تسجيل الخروج",
      dashTitle: "لوحة الإدارة",
      dashSubtitle: "نظرة عامة على المنصة (مباشرة من Firestore).",
      statTotalListings: "إجمالي الإعلانات",
      statInDatabase: "في قاعدة البيانات",
      statRegisteredUsers: "المستخدمون المسجّلون",
      statUsersCollection: "مجموعة users",
      statDealerProfiles: "ملفات الوكلاء",
      statDealersCollection: "مجموعة dealers",
      statRevenueMtd: "الإيرادات (الشهر الحالي)",
      statConnectBilling: "اربط الفوترة عند الجاهزية",
      volumeTitle: "حجم الإعلانات",
      volumeBody: "يمكن إضافة رسوم أسبوعية عند تخزين مقاييس مجمّعة. حالياً يُعرض عدد الإعلانات أعلاه.",
      quickLinksTitle: "روابط سريعة",
      quickReviewListings: "مراجعة الإعلانات",
      quickManageDealers: "إدارة الوكلاء",
      quickManageUsers: "إدارة المستخدمين",
      recentListingsTitle: "أحدث الإعلانات",
      loading: "جاري التحميل…",
      noListingsFirestore: "لا توجد إعلانات في Firestore بعد.",
      activityListing: (year, make, model) => `إعلان — ${year} ${make} ${model}`,
      activityRecent: "أُدرج مؤخراً",
      listingsTitle: "إدارة الإعلانات",
      errLoadListings: "فشل تحميل الإعلانات.",
      errApprove: "فشل الموافقة.",
      errDelete: "فشل الحذف.",
      errFlag: "فشل الإبلاغ.",
      colListing: "الإعلان",
      colSeller: "البائع",
      colPrice: "السعر",
      colStatus: "الحالة",
      colActions: "إجراءات",
      noListingsMatch: "لا توجد إعلانات",
      listedToday: "أُدرج اليوم",
      listedDaysAgo: (n) => `أُدرج منذ ${n} يوم${n === 1 ? "" : "اً"}`,
      reported: "مُبلّغ عنه",
      btnApprove: "موافقة",
      btnReject: "رفض",
      btnFlag: "إبلاغ",
      btnRemove: "إزالة",
      btnRestore: "استعادة",
      btnDelete: "حذف",
      filterAll: "الكل",
      filterPending: "قيد المراجعة",
      filterActive: "نشط",
      filterFlagged: "مُبلّغ",
      filterSold: "مباع",
      filterPaused: "موقوف",
      filterVerified: "موثّق",
      filterDealer: "وكيل",
      filterBanned: "محظور",
      usersTitle: "إدارة المستخدمين",
      errLoadUsers: "فشل تحميل المستخدمين.",
      errBan: "فشل الحظر.",
      errUnban: "فشل إلغاء الحظر.",
      errDeleteUser: "فشل الحذف.",
      colUser: "المستخدم",
      colType: "النوع",
      colRole: "الدور",
      colJoined: "تاريخ الانضمام",
      noUsersFound: "لا مستخدمين",
      searchPlaceholder: "بحث…",
      btnEmail: "بريد",
      btnBan: "حظر",
      btnUnban: "إلغاء الحظر",
      dealersTitle: "إدارة الوكلاء",
      statTotalDealers: "إجمالي الوكلاء",
      statDealersInCollection: "في مجموعة dealers",
      statMonthlyRevenue: "الإيرادات الشهرية",
      statPendingVerification: "قيد التحقق",
      statNotVerifiedYet: "لم يُتحقق بعد",
      colDealer: "الوكيل",
      colPlan: "الخطة",
      colListings: "الإعلانات",
      colRevenue: "الإيرادات",
      noDealersFound: "لا وكلاء",
      dealerSince: (joined) => `منذ ${joined}`,
      btnView: "عرض",
      reportsLoadFailed: "فشل تحميل التقارير.",
      reportsColIssue: "المشكلة",
      reportsColListing: "الإعلان",
      reportsColStatus: "الحالة",
      reportsColActions: "إجراءات",
      reportsNoReports: "لا تقارير.",
      btnResolve: "حل",
      btnViewAd: "عرض الإعلان",
      reportStatusOpen: "مفتوح",
      reportStatusResolved: "تم الحل",
      dashLoadingEllipsis: "…",
    },
    home: {
      badge: "سوق السيارات المميز في الكويت",
      h1a: "الطريقة الأذكى",
      h1b: "لشراء وبيع السيارات",
      subtitle: "إعلانات موثقة، أسعار شفافة، وتواصل مباشر عبر واتساب. بلا إعلانات ولا ضجيج.",
      browseCars: "تصفح السيارات ←",
      listYourCar: "أضف سيارتك",
      statsLabels: ["إعلان نشط", "وكيل موثق", "مواصفات خليجية", "مراجعة الإعلانات"],
      browseByMake: "تصفح حسب الماركة",
      viewAll: "عرض الكل ←",
      featuredListings: "إعلانات مميزة",
      seeAll: "عرض جميع الإعلانات ←",
      whyCarva: "لماذا كارفا",
      trust: [
        { title: "بائعون موثقون", desc: "كل وكيل يخضع للتحقق. البائعون الخاصون يمرون بالتحقق من الهوية قبل النشر." },
        { title: "تاريخ المركبة", desc: "تقارير كاملة عن الحوادث والملكية وسجل الصيانة متاحة لكل إعلان." },
        { title: "واتساب مباشر", desc: "تواصل مع البائعين فوراً عبر واتساب — بلا وسطاء، بلا رسوم خفية، بلا تأخير." },
      ],
      sellTitle: "هل أنت مستعد لبيع سيارتك؟",
      sellDesc: "أضف إعلانك في أقل من 5 دقائق. الوصول إلى آلاف المشترين الموثقين في الكويت.",
      sellBtn: "أضف سيارتك ←",
      footerCopy: "© 2025 كارفا. سوق السيارات المميز في الكويت.",
      footerLinks: ["الخصوصية", "الشروط", "تواصل معنا"],
      dealLabels: { great: "سعر ممتاز", good: "سعر جيد", fair: "سعر عادل" },
    },
    listings: {
      badge: "سوق السيارات المميز في الكويت",
      title: "ابحث عن سيارتك",
      statsLabels: ["إعلان", "وكيل", "موثق"],
      allMakes: "كل الماركات",
      allModels: "كل الموديلات",
      anyYear: "أي سنة",
      anyPrice: "أي سعر",
      sellerAll: "الكل",
      sellerDealer: "وكلاء",
      sellerPrivate: "خاص",
      sort: "ترتيب:",
      carsAvailable: n => `${n} سيارة متاحة`,
      clearFilters: "مسح الفلاتر",
      loading: "جاري التحميل...",
      noMatch: "لا توجد سيارات تطابق الفلاتر",
      clearAll: "مسح كل الفلاتر",
      whatsapp: "واتساب",
      privateSeller: "بائع خاص",
      listedToday: "أضيف اليوم",
      listedYesterday: "أضيف أمس",
      listedDaysAgo: n => `أضيف منذ ${n} أيام`,
      dealLabels: { great: "سعر ممتاز", good: "سعر جيد", fair: "سعر عادل" },
      tabOverview: "نظرة عامة",
      tabDetails: "التفاصيل",
      tabMarket: "السوق",
      mileage: "المسافة",
      fuel: "الوقود",
      transmission: "ناقل الحركة",
      specification: "المواصفات",
      color: "اللون",
      seller: "البائع",
      priceAnalysis: "تحليل السعر",
      avgMarket: "متوسط السوق",
      thisListing: "هذا الإعلان",
      saving: "التوفير",
      contactWhatsApp: "تواصل عبر واتساب",
      save: "تابع",
      verified: "موثق",
      history: "سجل السيارة",
      inspected: "مفحوص",
    },
    car: {
      loading: "جاري التحميل...",
      notFound: "الإعلان غير موجود",
      loadError: "تعذر تحميل الإعلان. يرجى المحاولة مرة أخرى.",
      backToListings: "العودة للإعلانات",
      breadcrumb: "الإعلانات",
      specifications: "المواصفات",
      sellerNotes: "ملاحظات البائع",
      marketIntel: "تحليل السوق",
      similarListings: "إعلانات مشابهة",
      specLabels: {
        Make: "الماركة", Model: "الموديل", Year: "السنة", Trim: "الإصدار",
        Mileage: "المسافة", Fuel: "الوقود", Transmission: "ناقل الحركة",
        Color: "اللون", Specification: "المواصفات", Condition: "الحالة",
      },
      privateSeller: "بائع خاص",
      listedToday: "اليوم",
      listedYesterday: "أمس",
      listedDaysAgo: n => `منذ ${n} أيام`,
      listedPrefix: "أضيف",
      avgMarket: "متوسط السوق",
      thisListing: "هذا الإعلان",
      youSave: "توفيرك",
      contactWhatsApp: "تواصل عبر واتساب",
      save: "تابع",
      share: "مشاركة",
      shareLinkCopied: "تم نسخ الرابط",
      saved: "تتم المتابعة",
      km: "كم",
      specSuffix: "المواصفات",
      currencyKwd: "د.ك",
      history: "السجل",
      inspected: "مفحوص",
      whatsappInterestMessage: (year, make, model) => `مرحبا، أنا مهتم بـ ${year} ${make} ${model}`,
      views: "مشاهدة",
      verified: "موثق",
      dealSignal: "إشارة الصفقة",
      report: "إبلاغ",
      reportTitle: "الإبلاغ عن هذا الإعلان",
      reportSubtitle: "أخبرنا بالمشكلة التي وجدتها.",
      reportPlaceholder: "اكتب تفاصيل المشكلة...",
      reportSubmitted: "تم إرسال البلاغ. شكراً لك.",
      reportFailed: "تعذر إرسال البلاغ.",
      submitReport: "إرسال البلاغ",
      submitting: "جاري الإرسال...",
      cancel: "إلغاء",
      marketIntelText: (dealLabel, make, model) => `تختلف الأسعار التقديرية حسب الحالة والمواصفات. هذا الإعلان مُصنّف كـ ${dealLabel} بالنسبة لسنة الصنع والمسافة. للحصول على صورة أدق للسوق، قارن مع إعلانات ${make} ${model} المشابهة على كارفا.`,
      dealLabels: { great: "سعر ممتاز", good: "سعر جيد", fair: "سعر عادل" },
      marketMedian: "متوسط السوق (الوسيط)",
      marketIntelNotEnough: "لا يوجد بعد إعلانات مقارنة كافية — تُحدَّث إشارة الصفقة تلقائياً عند إضافة المزيد من الإعلانات.",
      marketIntelBasedOn: (count, make, model) => `استناداً إلى ${count} إعلاناً مشابهاً لـ ${make} ${model} على كارفا`,
      mileageVsAverageBelow: (km) => `المسافة أقل بمقدار ${km.toLocaleString()} كم عن متوسط هذا الموديل`,
      mileageVsAverageAbove: (km) => `المسافة أعلى بمقدار ${km.toLocaleString()} كم عن متوسط هذا الموديل`,
      mileageVsAverageMatch: "المسافة قريبة من متوسط هذا الموديل",
      priceVsComparables: "السعر مقارنة بالمشابهين",
    },
    dealers: {
      badge: "وكلاء الكويت الموثقون",
      title: "ابحث عن وكيل",
      statsValues: ["340+", "98%", "خليجي"],
      statsLabels: ["وكيل", "موثق", "متخصصون"],
      searchPlaceholder: "ابحث عن اسم الوكيل أو الماركة...",
      specialties: ["الكل", "الفاخرة والأداء العالي", "متخصصو الألمانية", "اليابانية والكورية", "الأمريكية والدفع الرباعي", "الفاخرة الأعلى", "متعدد الماركات"],
      dealersFound: n => `${n} وكيل`,
      listings: "إعلان",
      since: "منذ",
      response: "الرد",
      whatsapp: "واتساب",
      viewShowroom: "عرض المعرض ←",
    },
    dealerProfile: {
      since: "منذ",
      responds: "يرد",
      active: "نشط",
      sold: "مباع",
      activeCars: "سيارة",
      whatsapp: "واتساب الوكيل",
      noListings: "لا توجد إعلانات لهذا الوكيل بعد.",
      loading: "جاري التحميل...",
      notFound: "الوكيل غير موجود",
      backToDealers: "العودة للوكلاء",
      listings: n => `${n} إعلان نشط`,
    },
    sell: {
      navTitle: "أضف سيارتك",
      saveDraft: "حفظ مسودة",
      steps: ["تفاصيل السيارة", "المواصفات والسعر", "الصور", "التواصل والمعاينة"],
      step0Title: "تفاصيل السيارة",
      step0Sub: "أخبرنا عن السيارة التي تريد بيعها.",
      categoryLabel: "الفئة",
      draftSaved: "تم حفظ المسودة. يمكنك المتابعة لاحقاً.",
      draftRestored: "تم استرجاع المسودة من الجلسة السابقة.",
      draftSaveFailed: "تعذر حفظ المسودة. حاول مرة أخرى.",
      draftSavedToAccount: "تم حفظ المسودة في قائمة إعلانات حسابك.",
      make: "الماركة", model: "الموديل", year: "السنة",
      trimLabel: "الإصدار", colorLabel: "اللون", specLabel: "المواصفة",
      selectMake: "اختر الماركة", selectModel: "اختر الموديل", selectYear: "اختر السنة",
      trimPlaceholder: "مثال: S Line, AMG, VXR",
      selectColor: "اختر اللون", selectSpec: "اختر المواصفات",
      step1Title: "المواصفات والسعر",
      step1Sub: "ساعد المشترين على فهم حالة السيارة وقيمتها.",
      fuel: "نوع الوقود", trans: "ناقل الحركة", mileage: "المسافة (كم)", condition: "الحالة",
      price: "السعر المطلوب (د.ك)", dealQuestion: "كيف تصف هذه الصفقة؟",
      selectFuel: "اختر نوع الوقود", selectTrans: "اختر ناقل الحركة",
      mileagePlaceholder: "مثال: 45000", selectCondition: "اختر الحالة",
      pricePlaceholder: "مثال: 12500",
      dealPreviewFootnote: "تُقدَّر درجة الصفقة تلقائياً من الإعلانات النشطة بعد نشر إعلانك — لا تختارها من هنا.",
      publishErrorMissingMakeModel: "اختر الماركة والموديل قبل النشر.",
      publishErrorInvalidYear: "اختر سنة صحيحة. للكلاسيك قبل 1980 اختر «قبل 1980».",
      publishErrorInvalidPrice: "أدخل سعراً صحيحاً (أرقام فقط).",
      publishErrorInvalidMileage: "أدخل مسافة صحيحة (أرقام فقط).",
      publishErrorNeedPhotos: "أضف صورة واحدة على الأقل قبل النشر.",
      submitErrorUnauthenticated: "يجب تسجيل الدخول للنشر. جرّب تسجيل الدخول مرة أخرى.",
      submitErrorRateLimited: "أرسلت عدة إعلانات خلال الساعة الماضية. انتظر قليلاً ثم حاول مرة أخرى.",
      submitErrorPermissionDenied: "ليس لديك صلاحية لإتمام هذا الإجراء.",
      submitErrorNotFound: "لم يُعثر على المسودة أو الإعلان. حدّث الصفحة وحاول مرة أخرى.",
      submitErrorTooManyImages: "عدد الصور كبير جداً. احذف بعض الصور وحاول مرة أخرى.",
      submitErrorInvalidImages: "رُفض أحد روابط الصور. أعد رفع الصور.",
      submitErrorMissingFields: "تفاصيل مطلوبة ناقصة أو غير صالحة. تحقق من الماركة والموديل والسنة والسعر والصور.",
      submitErrorInvalidArgument: "الخادم لم يقبل هذا الإرسال. تحقق من التفاصيل وحاول مرة أخرى.",
      submitErrorGeneric: "حدث خطأ أثناء النشر. حاول مرة أخرى.",
      submitErrorUploadBlocked: (uid) =>
        `تعذر الرفع: تحقق من قواعد التخزين للسماح بالكتابة إلى listings/${uid}.`,
      dealOptions: [
        { label: "سعر ممتاز", hint: "السعر أقل من السوق" },
        { label: "سعر جيد", hint: "أقل قليلاً من السوق" },
        { label: "سعر عادل", hint: "بسعر السوق" },
      ],
      step2Title: "الصور",
      step2Sub: "الإعلانات التي تحتوي على صور أكثر تحصل على 3 أضعاف الاستفسارات. أول صورة ستكون الغلاف.",
      dropText: "اسحب الصور هنا أو انقر للرفع",
      dropHint: "حتى 10 صور · JPG, PNG · الحجم الأقصى 10MB",
      cover: "غلاف",
      photosAdded: n => `تمت إضافة ${n} صورة`,
      remaining: n => `${n} متبقية`,
      step3Title: "التواصل والمعاينة",
      step3Sub: "سيتواصل معك المشترون مباشرة عبر واتساب.",
      businessNameLabel: "اسم المنشأة",
      yourName: "اسمك", whatsappNum: "رقم الواتساب", notesLabel: "ملاحظات إضافية",
      namePlaceholder: "مثال: أحمد الراشدي",
      whatsappPlaceholder: "مثال: 96599887766",
      whatsappHelper: "هذا الرقم الذي سيستخدمه المشترون للتواصل معك. يمكنك تحديثه من ملفك الشخصي.",
      notesPlaceholder: "أي شيء يجب أن يعرفه المشترون — سجل الصيانة، الإصلاحات الأخيرة، سبب البيع...",
      termsText: "بالإرسال، تؤكد دقة الإعلان وتوافق على",
      termsLink: "شروط الخدمة",
      termsEnd: ". يتم مراجعة الإعلانات خلال ساعتين.",
      back: "رجوع ←",
      continue: "التالي ←",
      publishing: "جاري النشر...",
      publish: "نشر الإعلان",
      livePreview: "معاينة مباشرة",
      previewDesc: "هكذا سيظهر إعلانك للمشترين",
      listingStrength: "قوة الإعلان",
      strengthItems: ["تفاصيل السيارة", "المواصفات والسعر", "الصور", "معلومات التواصل"],
      complete: n => `${n}% مكتمل`,
      successTitle: "تم إرسال الإعلان!",
      successDesc: "تم إرسال سيارتك للمراجعة. سنبلغك بمجرد نشره — عادةً خلال ساعتين.",
      successTitleDealer: "تم نشر الإعلان!",
      successDescDealer: "إعلانك الآن نشط وظاهر للمشترين.",
      listAnother: "أضف سيارة أخرى",
      backToDashboard: "العودة إلى لوحة التحكم",
      backToHome: "العودة إلى الصفحة الرئيسية",
      limitedEditNavTitle: "تحديث الإعلان",
      limitedEditTitle: "تحديث إعلانك",
      limitedEditSub: "يمكنك تغيير المسافة المقطوعة وسعر الطلب والصور والملاحظات فقط. بقية التفاصيل كما في الملف.",
      limitedEditBannerLive: "هذا الإعلان منشور. الحفظ يطبّق التغييرات فوراً.",
      limitedEditBannerPaused: "هذا الإعلان متوقف. يمكنك تحديث التفاصيل؛ يبقى الإيقاف حتى تفعّله من إعلاناتي.",
      limitedEditBannerPending: "هذا الإعلان ما زال قيد المراجعة. يمكنك تعديل هذه الحقول؛ يبقى في حالة المراجعة.",
      saveListingChangesLive: "حفظ التغييرات",
      saveListingChangesPending: "حفظ التحديثات",
      savingChanges: "جاري الحفظ…",
      successUpdatedTitle: "تم حفظ التغييرات",
      successUpdatedDesc: "تم تحديث إعلانك ويظهر للمشترين بالتفاصيل الجديدة.",
      successUpdatedPendingDesc: "تم حفظ التحديثات. الإعلان ما زال قيد المراجعة.",
      backToMyListings: "العودة إلى إعلاناتي",
      editListingNotFound: "تعذر العثور على هذا الإعلان.",
      editListingNotOwner: "يمكنك تعديل إعلاناتك فقط.",
      editListingNotEditable: "لا يمكن تعديل هذا الإعلان من هنا (قد يكون مباعاً أو غير متاح).",
      editListingLoadFailed: "تعذر تحميل الإعلان. حاول مرة أخرى.",
      editListingLoading: "جاري تحميل الإعلان…",
      partialSaveInvalidNumbers: "أدخل أرقاماً صحيحة للمسافة والسعر.",
      limitedStrengthMileagePrice: "المسافة والسعر",
      limitedStrengthPhotos: "الصور",
    },
    account: {
      profile: "الملف الشخصي",
      myListings: "إعلاناتي",
      signOut: "تسجيل الخروج",
      privateSeller: "بائع خاص",
      carDealer: "وكيل سيارات",
      editProfile: "تعديل الملف الشخصي",
      profileSub: "تحديث معلوماتك الشخصية.",
      fullName: "الاسم الكامل",
      whatsapp: "رقم الواتساب",
      email: "البريد الإلكتروني",
      emailNote: "لا يمكن تغيير البريد الإلكتروني.",
      saveChanges: "حفظ التغييرات",
      saving: "جاري الحفظ...",
      changesSaved: "تم الحفظ ✓",
      myListingsTitle: "إعلاناتي",
      myListingsSub: "السيارات التي أضفتها في كارفا.",
      noListings: "لم تضف أي سيارات بعد.",
      listACar: "أضف سيارة ←",
      loading: "جاري التحميل...",
      savedTitle: "الإعلانات المتابَعة",
      savedSub: "الإعلانات التي تتابعها للرجوع إليها لاحقاً.",
      noSaved: "لا توجد إعلانات متابَعة بعد.",
      browseCars: "تصفح السيارات ←",
      carOffice: "مكتب سيارات",
      removeFromSaved: "إزالة من المتابَعة",
      saved: "متابَع",
      savedYesterday: "تمت المتابعة أمس",
      savedDaysAgo: (n) => `تمت المتابعة منذ ${n} أيام`,
      savedCount: (n) => `${n} إعلان متابَع`,
      clearAll: "مسح الكل",
      loadingSavedCars: "جاري تحميل الإعلانات المتابَعة…",
      savedHint: "اضغط زر المتابعة على أي إعلان لإضافته هنا",
      cancel: "إلغاء",
      delete: "حذف",
      deleteListingTitle: "حذف الإعلان",
      deleteListingMessage: "سيتم حذف الإعلان نهائياً. لا يمكن التراجع عن هذا الإجراء.",
      activeListings: "الإعلانات النشطة",
      totalViews: "إجمالي المشاهدات",
      totalEnquiries: "إجمالي الاستفسارات",
      enquiries: "استفسارات",
      filterAll: "الكل",
      statusActive: "نشط",
      statusDraft: "مسودة",
      statusPaused: "متوقف",
      statusSold: "مباع",
      newListing: "+ إعلان جديد",
      loadingListings: "جاري تحميل الإعلانات…",
      noListingsForFilter: (f) => `لا توجد إعلانات ${f === "الكل" ? "" : f}`,
      postFirstCar: "+ أضف أول سيارة لك",
      listedDaysAgo: (n) => `أُدرج منذ ${n} أيام`,
      resume: "استكمال",
      edit: "تعديل",
      pause: "إيقاف",
      activate: "تفعيل",
      couldNotLoadProfile: "تعذر تحميل الملف الشخصي",
      saveFailed: "فشل الحفظ",
      loadingProfile: "جاري تحميل الملف الشخصي…",
      profileInformation: "معلومات الملف الشخصي",
      profileInfoHint: "هكذا سيراك المشترون في الإعلانات.",
      profilePhoto: "صورة الملف",
      fullNamePlaceholder: "اسمك الكامل",
      whatsappPlaceholder: "مثال: 96599887766",
      whatsappHint: "المشترون يتواصلون معك عبر هذا الرقم",
      emailManagedHint: "البريد الإلكتروني تتم إدارته عبر مزود تسجيل الدخول",
      location: "الموقع",
      locationPlaceholder: "مثال: مدينة الكويت",
      bio: "نبذة",
      optional: "اختياري",
      bioPlaceholder: "عرّف المشترين بنفسك باختصار...",
      password: "كلمة المرور",
      passwordHint: "غيّر كلمة مرور حسابك.",
      changePassword: "تغيير كلمة المرور",
      currentPassword: "كلمة المرور الحالية",
      currentPasswordPlaceholder: "أدخل كلمة المرور الحالية",
      newPassword: "كلمة المرور الجديدة",
      newPasswordPlaceholder: "أنشئ كلمة مرور جديدة",
      confirmNewPassword: "تأكيد كلمة المرور الجديدة",
      confirmNewPasswordPlaceholder: "أعد كتابة كلمة المرور الجديدة",
      updatePassword: "تحديث كلمة المرور",
      passwordFillAll: "يرجى تعبئة جميع حقول كلمة المرور.",
      passwordMismatch: "كلمة المرور الجديدة وتأكيدها غير متطابقين.",
      passwordTooShort: "يجب أن تكون كلمة المرور 6 أحرف على الأقل.",
      passwordWrongCurrent: "كلمة المرور الحالية غير صحيحة.",
      passwordUpdated: "تم تحديث كلمة المرور بنجاح.",
      passwordUpdateFailed: "فشل تحديث كلمة المرور. يرجى المحاولة مرة أخرى.",
      passwordProviderUnsupported: "تغيير كلمة المرور غير متاح لطريقة تسجيل الدخول هذه.",
      permanentlyDeleteAccount: "حذف الحساب نهائياً",
      deleteAccountHint: "احذف حسابك وجميع إعلاناتك نهائياً. لا يمكن التراجع عن ذلك.",
      deleteAccount: "حذف الحساب",
      deleting: "جاري الحذف...",
      deleteConfirm: "هل تريد حذف حسابك نهائياً؟ سيتم حذف ملفك الشخصي وكل إعلاناتك.",
      reloginToDelete: "لأسباب أمنية، يرجى تسجيل الدخول مرة أخرى ثم إعادة محاولة الحذف.",
      deleteFailed: "فشل حذف الحساب.",
      featured: "مميز",
      highlighted: "تعزيز",
      refresh: "تحديث",
      refreshed: "تم التحديث",
      featured7d: "مميز (7 أيام)",
      highlighted7d: "تعزيز (7 أيام)",
      refreshOneTime: "تحديث (مرة واحدة)",
      featured7dDesc: "أولوية في النتائج المطابقة بالترتيب الافتراضي لمدة 7 أيام مع فرصة ظهور متناوب في الرئيسية، دون ضمان المركز الأول.",
      highlighted7dDesc: "مظهر تعزيز وظهور أوضح لمدة 7 أيام.",
      refreshOneTimeDesc: "إعادة الإعلان لأعلى النتائج مرة واحدة.",
      processing: "جاري المعالجة...",
      payAndActivate: "ادفع وفعّل",
      featureHowItWorks: "طريقة عمل الميزات",
      duration7Days: "7 أيام",
      durationOneTime: "مرة واحدة",
      paidFeatureUnavailable: "التعزيزات المدفوعة غير متاحة حالياً.",
      paidFeatureErrorGeneric: "تعذر تفعيل التعزيز. أعد المحاولة أو تأكد من نشر Cloud Functions.",
      paidFeatureErrorRefreshUsed: "تم استخدام التحديث مسبقاً لهذا الإعلان.",
      paidFeatureErrorNotFound: "الإعلان غير موجود.",
      paidFeatureErrorPermission: "يمكنك تعزيز إعلاناتك فقط.",
      paidFeatureErrorSignIn: "يرجى تسجيل الدخول مرة أخرى للمتابعة.",
    },
    auth: {
      login: {
        title: "تسجيل الدخول إلى كارفا",
        subtitle: "حيّاك مرة ثانية في كارفا",
        noAccount: "ليس لديك حساب؟",
        signUp: "إنشاء حساب",
        emailLabel: "البريد الإلكتروني",
        passwordLabel: "كلمة المرور",
        emailPlaceholder: "example@email.com",
        passwordPlaceholder: "أدخل كلمة المرور",
        forgotPassword: "نسيت كلمة المرور؟",
        logIn: "تسجيل الدخول",
        loggingIn: "جاري الدخول...",
        orContinueWith: "أو تابع بـ",
        continueWithGoogle: "المتابعة بجوجل",
        noAccountFull: "ليس لديك حساب؟",
        signUpFree: "سجل مجاناً",
        fillAll: "يرجى ملء جميع الحقول.",
        show: "إظهار",
        hide: "إخفاء",
      },
      signup: {
        alreadyHave: "لديك حساب بالفعل؟",
        logIn: "تسجيل الدخول",
        step1Title: "إنشاء حسابك",
        step1Subtitle: "ما الذي يصفك أكثر؟",
        privateSeller: "بائع خاص",
        privateDesc: "أريد شراء أو بيع سيارتي الشخصية",
        carDealer: "وكيل سيارات",
        dealerDesc: "أدير معرضاً وأريد إدراج سيارات متعددة",
        continue: "التالي ←",
        step2Title: "بياناتك",
        step2SubtitleDealer: "أخبرنا عنك وعن معرضك.",
        step2SubtitlePrivate: "أخبرنا قليلاً عن نفسك.",
        fullName: "الاسم الكامل",
        dealershipName: "اسم المعرض",
        whatsapp: "رقم الواتساب",
        emailAddress: "البريد الإلكتروني",
        namePlaceholder: "مثال: أحمد الراشدي",
        dealerPlaceholder: "مثال: معرض الخليج للسيارات",
        whatsappPlaceholder: "مثال: 96599887766",
        emailPlaceholder: "example@email.com",
        back: "رجوع",
        step3Title: "إنشاء كلمة مرور",
        step3Subtitle: "8 أحرف على الأقل.",
        password: "كلمة المرور",
        confirmPassword: "تأكيد كلمة المرور",
        passwordPlaceholder: "أنشئ كلمة مرور",
        confirmPlaceholder: "أعد كتابة كلمة المرور",
        strengthWeak: "ضعيفة",
        strengthGood: "جيدة",
        strengthStrong: "قوية",
        terms: "بالتسجيل توافق على",
        termsLink: "شروط الخدمة",
        and: "و",
        privacyLink: "سياسة الخصوصية",
        createAccount: "إنشاء الحساب",
        creating: "جاري الإنشاء...",
        fillAll: "يرجى ملء جميع الحقول.",
        selectType: "يرجى اختيار نوع الحساب.",
        passwordMismatch: "كلمتا المرور غير متطابقتين.",
        passwordShort: "يجب أن تكون كلمة المرور 8 أحرف على الأقل.",
        doneTitle: "تم إنشاء الحساب!",
        doneWelcome: n => `مرحباً في كارفا، ${n}.`,
        doneVerify: "تحقق من بريدك الإلكتروني لتفعيل حسابك.",
        startBrowsing: "ابدأ التصفح ←",
        show: "إظهار",
        hide: "إخفاء",
      },
      forgot: {
        backToLogin: "رجوع لتسجيل الدخول ←",
        formTitle: "نسيت كلمة المرور؟",
        formSubtitle: "لا تقلق. أدخل بريدك الإلكتروني وسنرسل لك رابط إعادة التعيين.",
        emailLabel: "البريد الإلكتروني",
        emailPlaceholder: "example@email.com",
        sendLink: "إرسال الرابط",
        sending: "جاري الإرسال...",
        sentTitle: "تحقق من صندوق الوارد",
        sentDesc: "لقد أرسلنا رابط إعادة التعيين إلى",
        didntGet: "لم تستلمه؟ تحقق من مجلد الرسائل غير المرغوب فيها أو حاول مجدداً.",
        tryDifferent: "جرب بريداً مختلفاً",
        backToLoginBtn: "العودة لتسجيل الدخول",
        rememberedIt: "تذكرتها؟",
        enterEmail: "يرجى إدخال بريدك الإلكتروني.",
        validEmail: "يرجى إدخال بريد إلكتروني صالح.",
      },
    },
  },
};
